/* BSD-055 part 2 (11 Oct 2026). Coping buy box add-on, loaded by sections/bsd-coping.liquid.
   Works alongside sections/hearth-main.liquid without editing it:
   - moves the two coping panels in above "Getting it to you";
   - drives hearth-main's quantity box from the length / slab calculator;
   - adds the sealing line to hearth-main's running total and button;
   - takes over Add to basket for single slabs (slab line + paired sealing line at the same quantity,
     "Length requested" note). Crates are left to hearth-main. */
(function () {
  if (window.__bsdCoping) return;
  window.__bsdCoping = true;

  var dataEl = document.getElementById('bsd-coping-data');
  var panels = document.getElementById('bsd-coping-panels');
  var fulfil = document.getElementById('hearth-panel-fulfil');
  if (!dataEl || !panels || !fulfil) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var variantsJson = [];
  try { variantsJson = JSON.parse(document.getElementById('hearth-variants-json').textContent); } catch (e) {}

  /* Move the panels into the buy box. */
  while (panels.firstElementChild) fulfil.parentNode.insertBefore(panels.firstElementChild, fulfil);
  /* The "need more" line sits above the basket button and its message form just below it. */
  var atcForm = document.getElementById('hearth-atc-form');
  var overEl = document.getElementById('bsd-cop-over'), askForm = document.getElementById('bsd-cop-ask-form');
  if (atcForm && overEl) atcForm.parentNode.insertBefore(overEl, atcForm);
  if (atcForm && askForm) atcForm.parentNode.insertBefore(askForm, atcForm.nextSibling);
  var okEl = document.getElementById('bsd-cop-ask-ok');
  if (okEl) setTimeout(function () { okEl.scrollIntoView({ block: 'center' }); }, 300);

  var S = { mode: 'length', sealed: false };
  var $ = function (id) { return document.getElementById(id); };
  var qtyInput = $('hearth-qty-input');
  if (qtyInput) qtyInput.max = 9999;

  function money(p) {
    var a = (p / 100).toFixed(2).split('.');
    a[0] = a[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '£' + a.join('.');
  }
  function parseMoney(t) { var n = parseFloat(String(t || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
  function currentVariantId() { var el = $('hearth-variant-id'); return el ? String(el.value) : ''; }
  function currentVariant() {
    var id = currentVariantId();
    for (var i = 0; i < variantsJson.length; i++) if (String(variantsJson[i].id) === id) return variantsJson[i];
    return null;
  }
  function isCrate() {
    var chip = document.querySelector('.hearth-option-chip.is-on[data-option-key="purchase type"]');
    return !!(chip && /crate/i.test(chip.dataset.value || ''));
  }
  function unitMm() {
    var v = D.variants[currentVariantId()];
    return (v && v.unit > 0) ? v.unit : (D.unitDefault || 800);
  }
  function sealService() {
    var v = D.variants[currentVariantId()];
    var t = (v && v.seal) ? v.seal : D.sealTitle;
    return D.seal[t] || null;
  }
  /* Crate slabs on the same product count as stock for single-slab orders (a crate is brought from Colchester). */
  function crateSlabs() {
    var total = 0;
    for (var k in D.variants) {
      var x = D.variants[k];
      if (!/crate/i.test(x.t || '')) continue;
      var m = /(\d+)\s*slabs/i.exec(x.t || ''); var per = m ? parseInt(m[1], 10) : 0;
      total += Math.max(0, x.stock) * per;
    }
    return total;
  }
  function singlesHere() { var v = D.variants[currentVariantId()]; return v ? Math.max(0, v.stock) : 0; }
  function capacity() { return singlesHere() + crateSlabs(); }
  /* Shopify stops at the single-slab stock while the variant is set to stop selling when out of stock ("limit"). */
  function shopifyLimited() { var v = D.variants[currentVariantId()]; return !!(v && v.limit); }
  /* Cap: while Shopify limits stock, the singles on hand; once it keeps selling, singles + slabs in crates. */
  /* What is already in the basket for this slab counts against the cap (two adds cannot pass the stock). */
  var inCart = {};
  function inBasket() { return inCart[currentVariantId()] || 0; }
  function cap() { return Math.max(0, (shopifyLimited() ? singlesHere() : capacity()) - inBasket()); }
  function overStock(n) { return n > cap(); }
  function needsTransfer(n) { return n + inBasket() > singlesHere(); }
  /* Working days (same rule as the hearth pages: weekends and UK bank holidays off). */
  function pad2(n) { return n < 10 ? '0' + n : String(n); }
  function isWorking(d) { var w = d.getDay(); if (w === 0 || w === 6) return false; return (D.holidays || []).indexOf(d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate())) === -1; }
  function addDays(n) { var d = new Date(); d.setHours(0, 0, 0, 0); var a = 0; while (a < n) { d.setDate(d.getDate() + 1); if (isWorking(d)) a++; } return d; }
  var DL = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'], DS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MO = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function longD(d) { return DL[d.getDay()] + ' ' + d.getDate() + ' ' + MO[d.getMonth()]; }
  function shortD(d) { return DS[d.getDay()] + ' ' + d.getDate() + ' ' + MO[d.getMonth()].slice(0, 3); }
  function extraDays(n) { return (needsTransfer(n) ? (D.transferDays || 0) : 0) + (S.sealed ? (D.sealDays || 0) : 0); }
  function dates(n) {
    var x = extraDays(n);
    return { extra: x, ready: addDays((D.collectDays || 1) + x), dMin: addDays((D.deliverMin || 3) + x), dMax: addDays((D.deliverMax || 5) + x) };
  }
  function readyNote(n) {
    var d = dates(n);
    return 'Collect from ' + shortD(d.ready) + ' · delivered ' + shortD(d.dMin) + ' – ' + shortD(d.dMax);
  }
  function allowOn() { var a = $('bsd-cop-allow'); return !!(a && a.checked); }
  function metres() { var m = parseFloat(($('bsd-cop-metres') || {}).value); return (m > 0) ? m : 0; }

  function calc() {
    var unitM = unitMm() / 1000;
    if (S.mode === 'slabs') {
      var n = parseInt(($('bsd-cop-slabs') || {}).value, 10);
      return { count: n > 0 ? n : 0, work: '' };
    }
    var m = metres();
    if (!m) return { count: 0, work: '' };
    var raw = m / unitM;
    var pct = D.allowPct || 10;
    var withA = allowOn() ? raw * (1 + pct / 100) : raw;
    var count = Math.ceil(withA - 1e-9);
    var work = allowOn() ? (D.extraNote || 'includes [pct]% extra').replace('[pct]', pct) : '';
    return { count: count, work: work };
  }

  function lengthNote(count) {
    if (S.mode !== 'length' || !metres()) return '';
    return metres() + ' m · ' + count + ' slabs' + (allowOn() ? ' incl. ' + (D.allowPct || 10) + '% allowance' : '');
  }

  var lastCount = null, wasCrate = false;
  function sync() {
    var crate = isCrate();
    document.body.classList.toggle('bsd-coping-crate', crate);
    document.body.classList.toggle('bsd-coping-single', !crate);
    var cn = $('bsd-cop-crate-note'); if (cn) cn.hidden = !crate;

    var svc = sealService();
    var sp = $('bsd-cop-seal-price'); if (sp) sp.textContent = svc ? '+' + money(svc.price) + ' a slab' : '';
    var sealedPick = document.querySelector('input[name="bsd-cop-seal"][value="yes"]');
    if (sealedPick) sealedPick.closest('label').style.display = svc ? '' : 'none';

    if (crate) { lastCount = null; if (qtyInput && (!wasCrate || parseInt(qtyInput.value, 10) < 1)) qtyInput.value = 1; wasCrate = true; fire(); return; }
    wasCrate = false;
    var r = calc();
    var ce = $('bsd-cop-count'); if (ce) ce.textContent = r.count + (r.count === 1 ? ' slab' : ' slabs');
    var we = $('bsd-cop-work'); if (we) we.textContent = r.work;
    var cv = $('bsd-cop-cover'); if (cv) cv.textContent = r.count ? 'covers ' + (r.count * unitMm() / 1000).toFixed(1) + ' m' : '';
    if (qtyInput) qtyInput.value = Math.max(1, r.count);
    lastCount = r.count;
    fire();
  }
  function fire() { if (qtyInput) qtyInput.dispatchEvent(new Event('input', { bubbles: true })); else patch(); }

  /* After hearth-main redraws the total, add the sealing line and fix the button. */
  var patching = false;
  function patch() {
    if (patching) return;
    patching = true;
    try {
      var lines = $('hearth-tot-lines'), grand = $('hearth-price-amount');
      var crate = isCrate();
      var count = crate ? null : lastCount;
      var svc = sealService();
      if (lines && grand && !crate && S.sealed && svc && count > 0 && !lines.querySelector('.bsd-cop-sealline')) {
        var row = document.createElement('div');
        row.className = 'hearth-tot__line bsd-cop-sealline';
        row.innerHTML = '<span></span><span></span>';
        row.firstChild.textContent = (D.sealLine || 'Sealing × [n]').replace('[n]', count);
        row.lastChild.textContent = money(svc.price * count);
        var first = lines.firstElementChild;
        if (first && first.nextSibling) lines.insertBefore(row, first.nextSibling); else lines.appendChild(row);
        var g = parseMoney(grand.textContent);
        if (g !== null) grand.textContent = money(g + svc.price * count);
      }
      if (!crate && count === 0 && lines) {
        var f = lines.firstElementChild;
        if (f && f.lastChild) f.lastChild.textContent = money(0);
        var g0 = parseMoney(grand && grand.textContent), v = currentVariant();
        if (grand && g0 !== null && v) grand.textContent = money(Math.max(0, g0 - v.price));
      }
      /* Real weight: Shopify weights are 1 kg / 1,000 kg for delivery rules (BSD-009); show custom.real_weight_kg instead. */
      var vd = D.variants[currentVariantId()] || {};
      var kgText = vd.kg > 0 ? (Math.round(vd.kg * 10) / 10) + ' kg' : '';
      var vl = $('hearth-varline');
      if (vl) vl.textContent = vl.textContent.replace(/\s*·\s*[\d,.]+\s*kg( a slab)?/, kgText ? ' · ' + kgText + (crate ? '' : ' a slab') : '');
      var hand = $('hearth-hand');
      if (hand) hand.textContent = hand.textContent.replace(/^[\d,.]+\s*kg[^.]*\.\s*/, kgText && !crate ? kgText + ' a slab. ' : '');
      if (lines && !crate && count > 0) {
        var l1 = lines.firstElementChild, v1 = currentVariant();
        if (l1 && l1.firstChild && v1 && !l1.classList.contains('bsd-cop-sealline')) l1.firstChild.textContent = count + ' × ' + String(v1.title).toLowerCase();
      }
      /* One delivery line instead of the collect/deliver panel: checkout makes the choice. */
      var dl = $('bsd-cop-delivery');
      if (dl) {
        var rate = $('hearth-deliver-price');
        dl.textContent = crate ? (D.crateDelivery || '') : (D.deliveryLine || '').replace('[price]', rate ? rate.textContent : '');
      }
      if (lines && lines.lastElementChild && /collection|pallet delivery/i.test(lines.lastElementChild.textContent)) lines.removeChild(lines.lastElementChild);
      var ov = $('bsd-cop-over');
      if (ov) {
        var showOver = !crate && count > 0 && overStock(count);
        ov.hidden = !showOver;
        if (showOver) ov.textContent = (inBasket() > 0 ? (D.askNoteCart || '') : (D.askNote || '')).replace('[c]', inBasket()).replace('[n]', cap());
        var askBox = $('bsd-cop-ask');
        if (askBox && !showOver && !askBox.hidden && !askBox.querySelector('.bsd-cop-ask__err')) askBox.hidden = true;
      }
      var sticky = $('hearth-sticky-price'); if (sticky && grand) sticky.textContent = grand.textContent;
      ['hearth-atc-btn', 'hearth-sticky-atc-btn'].forEach(function (id) {
        var b = $(id); if (!b || crate) return;
        var v = currentVariant();
        if (v && !v.available) return;
        if (!count) { b.disabled = true; b.textContent = D.noLength; }
        else if (overStock(count)) { b.disabled = false; b.textContent = (D.overStock || 'NEED MORE THAN [n]? MESSAGE US').replace('[n]', cap()); }
        else if (/ADD TO BASKET|ENTER A|SLABS TO BASKET/i.test(b.textContent)) { b.disabled = false; var t = (D.addN || 'ADD [n] SLABS TO BASKET ➔').replace('[n]', count); b.textContent = count === 1 ? t.replace(/SLABS/, 'SLAB') : t; }
      });
      /* Dates: when sealing or a Colchester crate adds days, replace hearth-main's stock-only arrival line. */
      var arr = $('hearth-arrive');
      /* One date line: collection date, delivery window, and (when needed) why it takes longer. */
      if (arr && !crate && count > 0 && !overStock(count)) {
        var dd = dates(count);
        arr.innerHTML = '';
        var bEl = document.createElement('b');
        bEl.textContent = 'Collect from ' + longD(dd.ready) + ' or delivered ' + shortD(dd.dMin) + ' – ' + shortD(dd.dMax) + '.';
        arr.appendChild(bEl);
        if (needsTransfer(count)) arr.appendChild(document.createTextNode(' ' + (D.transferLine || '').replace('[a]', singlesHere()).replace('[b]', count + inBasket() - singlesHere())));
        arr.style.display = 'block';
      } else if (arr && !crate && (!count || overStock(count))) { arr.style.display = 'none'; }
    } finally { patching = false; }
  }
  var linesEl = $('hearth-tot-lines');
  if (linesEl && 'MutationObserver' in window) new MutationObserver(function () { patch(); }).observe(linesEl, { childList: true });

  /* Controls */
  document.querySelectorAll('.bsd-cop-tabs button').forEach(function (b) {
    b.addEventListener('click', function () {
      S.mode = b.dataset.mode;
      document.querySelectorAll('.bsd-cop-tabs button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      document.querySelectorAll('.bsd-cop-body[data-pane]').forEach(function (p) { p.hidden = p.dataset.pane !== S.mode; });
      if (S.mode === 'slabs' && lastCount > 0) $('bsd-cop-slabs').value = lastCount;
      var f = $(S.mode === 'slabs' ? 'bsd-cop-slabs' : 'bsd-cop-metres'); if (f) f.focus();
      sync();
    });
  });
  ['bsd-cop-metres', 'bsd-cop-slabs'].forEach(function (id) { var el = $(id); if (el) el.addEventListener('input', sync); });
  var al = $('bsd-cop-allow'); if (al) al.addEventListener('change', sync);
  document.querySelectorAll('input[name="bsd-cop-seal"]').forEach(function (r) {
    r.addEventListener('change', function () {
      S.sealed = r.value === 'yes' && r.checked;
      document.querySelectorAll('input[name="bsd-cop-seal"]').forEach(function (x) { x.closest('label').classList.toggle('is-on', x.checked); });
      sync();
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.hearth-option-chip')) setTimeout(sync, 0);
  });

  /* Add to basket for single slabs (capture phase, ahead of hearth-main's own handler). */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    /* getAttribute: the form has an input named "id", so form.id is that input, not the form's id. */
    if (!form || !form.getAttribute || form.getAttribute('id') !== 'hearth-atc-form' || isCrate()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var v = currentVariant(); if (v && !v.available) return;
    var count = lastCount;
    if (count && overStock(count)) { openAsk(count); return; }
    if (!count) return;
    var btns = [$('hearth-atc-btn'), $('hearth-sticky-atc-btn')];
    btns.forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'ADDING...'; } });
    var svc = S.sealed ? sealService() : null;
    var props = {};
    var note = lengthNote(count); if (note) props['Length requested'] = note;
    if (extraDays(count) > 0) props['Ready'] = readyNote(count);
    if (needsTransfer(count)) props['Stock'] = 'Needs a Colchester crate transfer (' + singlesHere() + ' singles at Milton Keynes, ' + (count + inBasket()) + ' in basket)';
    if (svc) props['Service'] = D.serviceProp || 'Deep Clean & Seal';
    [['hearth-contractor-name', 'Installer name'], ['hearth-contractor-phone', 'Installer phone'], ['hearth-contractor-email', 'Installer email']].forEach(function (p) {
      var el = $(p[0]); if (el && !el.disabled && el.value) props[p[1]] = el.value;
    });
    var items = [{ id: parseInt(currentVariantId(), 10), quantity: count, properties: props }];
    if (svc) {
      var img = (v && v.featured_image && v.featured_image.src) ? v.featured_image.src : D.image;
      items.push({ id: svc.id, quantity: count, properties: { 'For product': D.productTitle, '_image': img, 'Slab': v ? v.title : '' } });
    }
    function add(item) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Add to basket failed'); return d; }); });
    }
    /* Sealing line first, slab second: Shopify lists the newest line first, so the slab shows above its sealing line.
       If the slab then fails, the sealing line just added is taken out again. */
    var firstItem = items[1] || items[0], secondItem = items[1] ? items[0] : null;
    add(firstItem).then(function (d) {
      if (!secondItem) return;
      var key = d && d.items && d.items[0] && d.items[0].key;
      return add(secondItem).catch(function (err) {
        if (!key) throw err;
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
          .then(function () { throw err; }, function () { throw err; });
      });
    })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        btns.forEach(function (b) { if (b) b.disabled = false; });
        sync();
        alert((err && err.message ? err.message + '\n\n' : '') + 'Please try again or call 01908 46 46 56.');
      });
  }, true);

  function openAsk(count) {
    var box = $('bsd-cop-ask'); if (!box) return;
    var t = $('bsd-cop-ask-title'); if (t) t.textContent = (D.askTitle || 'Need more than [n]?').replace('[n]', cap());
    var q = $('bsd-cop-ask-qty'); if (q) q.value = count;
    var sl = $('bsd-cop-ask-sealed'); if (sl) sl.value = S.sealed ? 'Sealed' : 'Unsealed';
    var st = $('bsd-cop-ask-stock'); if (st) st.value = singlesHere() + ' singles at Milton Keynes, ' + crateSlabs() + ' slabs in crates' + (inBasket() ? ', ' + inBasket() + ' already in basket' : '');
    var pr = $('bsd-cop-ask-prod'); if (pr) pr.textContent = D.productTitle + ' · ' + (S.sealed ? 'sealed' : 'unsealed');
    box.hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var nm = $('bsd-cop-ask-name'); if (nm) setTimeout(function () { (nm.value ? $('bsd-cop-ask-email') : nm).focus(); }, 400);
  }
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
    (c.items || []).forEach(function (i) { inCart[String(i.variant_id)] = (inCart[String(i.variant_id)] || 0) + i.quantity; });
    sync();
  }).catch(function () {});

  /* Start on single slabs, like the mock-up. */
  if (!document.querySelector('.hearth-option-chip.is-on[data-option-key="purchase type"]')) {
    var single = document.querySelector('.hearth-option-chip[data-option-key="purchase type"]:not([disabled])');
    if (single && !/crate/i.test(single.dataset.value || '')) single.click();
  }
  sync();
})();
